import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ClaimService } from '../../../services/claim.service';
import { LoginService } from '../../../services/login.service';


interface PolicyBanner {
  messageText: string;
  id: string;
}

interface PolicyBannerResponse {
  data: {
    portalBanners: PolicyBanner[];
  };
}

@Component({
  selector: 'upsc-partner-banner',
  templateUrl: './partner-banner.component.html',
  styleUrls: ['./partner-banner.component.scss']
})
export class PartnerBannerComponent implements OnInit, OnDestroy {
  showBanner: boolean = false;
  banners: PolicyBanner[] = [];
  currentPartner: string = ''; // current partner for font
  private subscription: Subscription = new Subscription();
  // List of known partner names to look for in URLs
  private knownPartnerNames: string[] = ['pirate-ship', 'inxpress', 'happy-returns'];

  constructor(
    private router: Router,
    private claimService: ClaimService,
    private loginService: LoginService
  ) {}

  ngOnInit(): void {
    const flowType = sessionStorage.getItem('flowType');
    
    // policy banners
    this.fetchPolicyBanners();
  }

 
  private fetchPolicyBanners(): void {
    let policyNumber = '';
    let partnerName = '';
    
    // partner name from URL path 
    const currentPath = this.router.url;
    
    // partner name from URL path
    const partnerNameFromUrl = this.extractPartnerNameFromUrl(currentPath);
    if (partnerNameFromUrl) {
      partnerName = partnerNameFromUrl.replace("/", "");
      this.currentPartner = partnerNameFromUrl.replace("/", ""); // Store for font
    }
    
    
    // Check if we have partnerName to make the API call
    if (!partnerName) {
      return;
    }

    
    this.subscription.add(
      this.claimService.getPolicyBanners('', policyNumber, partnerName)
        .subscribe(
          response => {
            
            if (response && response.data && response.data.portalBanners && response.data.portalBanners.length > 0) {
              
              // Store all banners from the API
              this.banners = response.data.portalBanners;
              this.showBanner = true;
              
            } else {
              this.showBanner = false;
            }
          }
        )
    );
  }

 
  private extractPartnerNameFromUrl(url: string): string {
    const landingURL = url.split('?')[0];  
    const urlSegments = landingURL.split('/');
    return urlSegments.length > 1 && urlSegments[1] ? urlSegments[1] : '';
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeBanner(): void {
    this.showBanner = false;
  }
}
